var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene"},[_c('scene1',{staticClass:"scene-1"}),_vm._v(" "),_c('scene2',{staticClass:"scene-2"}),_vm._v(" "),_c('scene3',{staticClass:"scene-3"}),_vm._v(" "),_c('div',{staticClass:"skip",attrs:{"title":"跳过引导"},on:{"click":_vm.goHome}},[_vm._v("SKIP")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c26802","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/scene/Scene.vue
// module id = null
// module chunks = 